import React, {useContext} from 'react';

import b_ from 'b_';

import {Select, RadioButton} from 'client/common/components/lego';

import {useDevice} from 'client/common/hooks/device';

import ListModeContext from 'client/common/contexts/list-mode';

import {StateFilterValue, ListMode} from 'client/common/store/reducers/surveys/types';

import {Device} from 'client/common/utils/device-width';
import I18N from 'assets/i18n/brandlift-project';

import {ComponentProps} from './types';

import './survey-state-filter.css';

const i18n = I18N.list.surveyStateFilter;
const b = b_.with('survey-state-filter');

const ALL_FILTERS = [
    StateFilterValue.All,
    StateFilterValue.Draft,
    StateFilterValue.Moderation,
    StateFilterValue.Active,
    StateFilterValue.Paused,
    StateFilterValue.Completed,
    StateFilterValue.Closed
];

const FILTERS = {
    [ListMode.User]: ALL_FILTERS,
    [ListMode.Agency]: ALL_FILTERS,
    [ListMode.AgencyClient]: ALL_FILTERS
};

function useFilters() {
    const listMode = useContext(ListModeContext);

    return FILTERS[listMode];
}

function RadioGroupFilter({stateFilter, changeStateFilter}: ComponentProps) {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        changeStateFilter({state: event.target.value as StateFilterValue});
    };

    const filters = useFilters();

    return (
        <RadioButton
            className={b('tabs')}
            size='m'
            view='default'
            value={stateFilter}
            onChange={handleChange}
            options={filters.map(value => ({value, children: i18n.state[value]}))}
        />
    );
}

function SelectFilter({stateFilter, changeStateFilter}: ComponentProps) {
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        changeStateFilter({state: e.target.value as StateFilterValue});
    };

    const filters = useFilters();

    return (
        <Select
            className={b('select')}
            size='m'
            options={filters.map(value => ({
                value,
                content: i18n.state[value]
            }))}
            value={stateFilter}
            view='default'
            onChange={handleChange}
        />
    );
}

export default function SurveyStateFilter(props: ComponentProps) {
    const {mix = ''} = props;

    const device = useDevice();

    const FilterComponent = [Device.Mobile, Device.Tablet].includes(device)
        ? SelectFilter
        : RadioGroupFilter;

    return (
        <div className={`${b()} ${mix}`}>
            <FilterComponent {...props} />
        </div>
    );
}
